exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".skiresort-switch .item{border:2px solid gray;color:gray;margin:10px 0;padding:5px;text-align:left;font-size:13px;cursor:pointer}.skiresort-switch .item.opened-resort{border:2px solid #4d88d6;color:#4d88d6}.skiresort-switch .item.selected{border:2px solid #4d88d6;background-color:#4d88d6;color:#fff;cursor:inherit}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader!./src/styles/panels.less
// module id = 913
// module chunks = 0